import React from 'react';
import '../Routes.css';

function Logout() {
  return (
    <div className="page__container">
      <h1 className="page__heading">Logout</h1>
    </div>
  );
}

export default Logout;
